const adminRole = 'Admin';
const editorRole = 'Editor';
const reviewsRole = 'Reviews';
const billingRole = 'Billing';

export {
  adminRole,
  editorRole,
  reviewsRole,
  billingRole
};
